<template>
  <v-app-bar
    app
    clipped-left
    fixed
  >
    <v-app-bar-nav-icon @click.stop="$emit('update:drawer', !drawer);"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ (controller) ? controller.displayName : "..." }}</v-toolbar-title>
    <v-progress-linear
      :active="saving || loading"
      :indeterminate="saving || loading"
      absolute
      bottom
      color="primary"
    ></v-progress-linear>
    <div class="flex-grow-1"></div>
    <bell></bell>
    <v-btn icon :loading="loading" :disabled="loading" @click="refresh">
      <v-icon>mdi-cached</v-icon>
    </v-btn>

    <!--<div class="approve px-4">
      <div class="v-timeline big-right" clipped="">
        <div class="v-timeline-item v-timeline-item--fill-dot v-timeline-item--after" style="">
          <div class="v-timeline-item__body">
            <div>&nbsp;</div>
          </div>
          <div class="v-timeline-item__divider">
            <v-fab-transition>
              <v-btn fab color="primary" v-show="showApprove" style="transition-delay: 0.1s">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-fab-transition>
          </div>
          <div class="v-timeline-item__opposite"><span class="caption">&nbsp;</span></div>
        </div>
      </div>
    </div>-->
  </v-app-bar>
</template>

<script>
import Bell from './../components/Bell.vue'
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapGetters([
      'controllerById',
    ]),
    controller() {
      return this.controllerById(this.controllerId)
    },
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    /*showApprove() {
      return (this.$route.name == 'notifications') ? true : false;
    },*/
    loading() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].loading || this.$store.state.alerts.loading
      } else {
        return true
      }
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving
      } else {
        return true
      }
    }
  },
  methods: {
    refresh() {
      this.$store.dispatch(`${this.moduleName}/syncController`, true)
    }
  },
  components: {
    Bell
  }
}
</script>

<style>

</style>